
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteP as ObiOwnShipRemotePElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-p.js';
 
 
 

 
 export const ObiOwnShipRemoteP = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-p',
   elementClass: ObiOwnShipRemotePElement,
   events: {
     
   }
  });
 
 